import tippy from 'tippy.js';

let instance;

const shareRecommendedCartModal = () => {
    $('.modal-backdrop').hide();
    $('#shareRecommendedModal').show();
};

const copyHandler = async () => {
    const link = $('.link-input').val();
    try {
        await navigator.clipboard.writeText(link);
        if(instance) {
            instance.show();
        }
    } catch (err) {
        console.error(err);
    }
};

function closeModal(e) {
    $(e.currentTarget).closest('.modal-backdrop').hide();
}

const initializeTooltip = () => {
    const btn = '.copy-link-btn';
    const text = $(btn).data('link-copied');
    [instance] = tippy(`${btn}`, {
        animation: 'shift-away-extreme',
        content: text || 'Link Copied!',
        trigger: 'manual',
        theme: 'copy-link',
        arrow: false,
        duration: [150, 150],
        onShow(instance) {
            setTimeout(() => {
                instance.hide();
            }, 2500);
        }
    });
};

$(function () {
    initializeTooltip();
    $('body').on('click', '.closeModal', closeModal);
    $('.open-btn-1').on('click', shareRecommendedCartModal);
    $('.copy-link-btn').on('click', copyHandler);
});
